import { render } from "./CartSelect.vue?vue&type=template&id=a71fd030"
import script from "./CartSelect.vue?vue&type=script&lang=js"
export * from "./CartSelect.vue?vue&type=script&lang=js"

import exportComponent from "/Users/bertog/Code/aitmes/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__